import { LAYOUTS, POSITION, } from '@voltmoney/types';
import { ActiveStateTokens, AvatarSizeTokens, AvatarTypeTokens, BorderRadiusTokens, ColorTokens, DividerSizeTokens, FontFamilyTokens, FontSizeTokens, HeaderTypeTokens, IconSizeTokens, IconTokens, SizeTypeTokens, StackAlignItems, StackJustifyContent, StackType, StackWidth, WIDGET, } from '@voltmoney/schema';
import { ROUTE } from '../../../routes';
import { ACTION } from './types';
import { aboutDetails, accountDetails, contactDetails, faqDetails, goBack, logout, navigateForeClosureTracking, navigateToForeclosure, navigateToLoanDetails, } from './actions';
import SharedPropsService from '../../../SharedPropsService';
import { shouldShowVoltContactUs } from '../../../configs/uri-config-utils';
import { CREDIT_STATUS, formatFullName, getBorrowerProfile, getManageLimitConfig, removeUrlWithoutReload, showNewForeClosureFlow, showUserLoanDetils } from '../../../configs/utils';
import { foreclosureTrackingFlag, QUERY_PARAMS, TARGET_PAGES } from '../../../configs/constants';
import { api } from '../../../configs/api';
import { getAppHeader } from '../../../configs/config';
import { Platform } from "react-native";
import AsyncStorage from '@react-native-async-storage/async-storage';
const buildListItem = (id, titleLabel, titleColor, titleFontWeight, iconName, iconColor, hasRightArrow, hasDivider, action) => {
    const uniqueId = `${titleLabel}`;
    const datastore = {
        [`${uniqueId}`]: {
            id: id,
            width: StackWidth.MATCH_PARENT,
            bgColor: ColorTokens.White,
            widgetItems: [
                { id: `spaceTop-${uniqueId}`, type: WIDGET.SPACE },
                { id: `leftStack-${uniqueId}`, type: WIDGET.STACK },
                { id: `spaceMiddle-${uniqueId}`, type: WIDGET.SPACE },
                { id: `divider-${uniqueId}`, type: WIDGET.DIVIDER },
            ],
        },
        [`leftStack-${uniqueId}`]: {
            type: StackType.row,
            width: StackWidth.FULL,
            alignItems: StackAlignItems.center,
            justifyContent: StackJustifyContent.spaceBetween,
            widgetItems: [
                { id: `leftLeftStack-${uniqueId}`, type: WIDGET.STACK },
                { id: `rightArrow-${uniqueId}`, type: WIDGET.ICON },
            ],
            action,
        },
        [`spaceMiddle-${uniqueId}`]: {
            size: SizeTypeTokens.MD,
        },
        [`divider-${uniqueId}`]: {
            size: DividerSizeTokens.SM,
            color: ColorTokens.Grey_Milk_1,
            margin: {
                vertical: SizeTypeTokens.SM,
            },
        },
        [`rightArrow-${uniqueId}`]: {
            name: IconTokens.ChervonDownRight,
            size: IconSizeTokens.XXL,
            color: ColorTokens.Grey_Night,
        },
        [`leftLeftStack-${uniqueId}`]: {
            type: StackType.row,
            alignItems: StackAlignItems.center,
            justifyContent: StackJustifyContent.flexStart,
            widgetItems: [
                { id: `iconNameStack-${uniqueId}`, type: WIDGET.STACK },
                { id: `horizontalSpace-${uniqueId}`, type: WIDGET.SPACE },
                { id: `title-${uniqueId}`, type: WIDGET.TEXT },
            ],
        },
        [`iconNameStack-${uniqueId}`]: {
            padding: {
                all: SizeTypeTokens.MD
            },
            justifyContent: StackJustifyContent.center,
            alignItems: StackAlignItems.center,
            borderConfig: {
                borderRadius: BorderRadiusTokens.BR6
            },
            bgColor: ColorTokens.Primary_05,
            widgetItems: [
                { id: `iconName-${uniqueId}`, type: WIDGET.ICON },
            ]
        },
        [`iconName-${uniqueId}`]: {
            name: iconName,
            color: iconColor,
            size: IconSizeTokens.XXL,
        },
        [`horizontalSpace-${uniqueId}`]: {
            size: SizeTypeTokens.LG,
        },
        [`title-${uniqueId}`]: {
            label: titleLabel,
            color: titleColor,
            numberOfLines: 1,
            fontSize: FontSizeTokens.SM,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: titleFontWeight,
            lineHeight: 20,
        },
        [`spaceTop-${uniqueId}`]: { size: SizeTypeTokens.MD },
    };
    if (!hasRightArrow) {
        delete datastore[`rightArrow-${uniqueId}`];
    }
    if (!hasDivider) {
        delete datastore[`divider-${uniqueId}`];
    }
    return datastore;
};
const menuList = (profileData, shouldShowContactUs, showForeclosure, preLoanFlowUI, showLogout, isLoanExpired, showForeclosureTracking, foreclosureTrackingResponse, showForeclosureTrackingFromFirebase, setIsUserLoggedIn, setShowSupportPhoneNumber, isLoanRenewalInProgress, showLoanDetails, showNewForeClosureScreen) => {
    const list = [
        {
            id: 'txt_profileScreen_accountDetails',
            iconName: IconTokens.Account_profile,
            titleLabel: 'Account details',
            titleFontWeight: '500',
            titleColor: ColorTokens.Grey_Night,
            position: POSITION.BODY,
            hasRightArrow: true,
            hasDivider: true,
            iconColor: ColorTokens.Primary_100,
            action: {
                type: ACTION.PROFILE,
                payload: {
                    value: profileData,
                },
                routeId: ROUTE.MY_PROFILE,
            },
        },
        {
            id: 'txt_profileScreen_loanDetails',
            iconName: IconTokens.MY_LOAN_PROFILE_ICON,
            titleLabel: 'My loan details',
            titleFontWeight: '500',
            titleColor: ColorTokens.Grey_Night,
            position: POSITION.BODY,
            hasRightArrow: true,
            hasDivider: true,
            iconColor: ColorTokens.Primary_100,
            action: {
                type: ACTION.LOAN_PROFILE,
                payload: {},
                routeId: ROUTE.MY_PROFILE,
            },
        },
        {
            id: 'txt_profileScreen_FAQ',
            iconName: IconTokens.Question,
            titleLabel: 'FAQs',
            titleFontWeight: '500',
            titleColor: ColorTokens.Grey_Night,
            position: POSITION.BODY,
            hasRightArrow: true,
            hasDivider: true,
            iconColor: ColorTokens.Primary_100,
            action: {
                type: ACTION.FAQ,
                payload: {},
                routeId: ROUTE.MY_PROFILE,
            },
        },
        {
            id: 'txt_profileScreen_contactUs',
            iconName: IconTokens.HeadPhone,
            titleLabel: 'Contact us',
            titleFontWeight: '500',
            titleColor: ColorTokens.Grey_Night,
            position: POSITION.BODY,
            hasRightArrow: true,
            hasDivider: true,
            iconColor: ColorTokens.Primary_100,
            action: {
                type: ACTION.CONTACT_US,
                payload: {},
                routeId: ROUTE.MY_PROFILE,
            },
        },
        {
            id: 'txt_profileScreen_trackClosureRequest',
            iconName: IconTokens.foreclosure,
            titleLabel: 'Track closure request',
            titleFontWeight: '500',
            titleColor: ColorTokens.Grey_Night,
            position: POSITION.BODY,
            hasRightArrow: true,
            hasDivider: true,
            iconColor: ColorTokens.Primary_100,
            action: {
                type: ACTION.TRACK_FORECLOSURE,
                payload: {
                    value: foreclosureTrackingResponse
                },
                routeId: ROUTE.MY_PROFILE,
            },
        },
        {
            id: 'txt_profileScreen_loanForeclosure',
            iconName: IconTokens.foreclosure,
            titleLabel: showNewForeClosureScreen ? 'Close account' : 'Loan closure',
            titleFontWeight: '500',
            titleColor: ColorTokens.Grey_Night,
            position: POSITION.BODY,
            hasRightArrow: true,
            hasDivider: true,
            iconColor: ColorTokens.Primary_100,
            action: {
                type: ACTION.FORECLOSE,
                payload: { showNewForeClosureScreen },
                routeId: ROUTE.MY_PROFILE,
            },
        },
        {
            id: 'txt_profileScreen_aboutUs',
            iconName: IconTokens.AboutUs,
            titleLabel: 'About us',
            titleFontWeight: '500',
            titleColor: ColorTokens.Grey_Night,
            position: POSITION.BODY,
            hasRightArrow: true,
            hasDivider: true,
            iconColor: ColorTokens.Primary_100,
            action: {
                type: ACTION.ABOUT,
                payload: {},
                routeId: ROUTE.MY_PROFILE,
            },
        },
        {
            id: 'txt_profileScreen_logOut',
            iconName: IconTokens.Logout_Profile,
            titleLabel: 'Logout',
            titleFontWeight: '600',
            titleColor: ColorTokens.Primary_100,
            position: POSITION.ABSOLUTE_BOTTOM,
            hasRightArrow: false,
            hasDivider: false,
            iconColor: ColorTokens.Primary_100,
            action: {
                type: ACTION.LOGOUT,
                payload: {
                    setIsUserLoggedIn: setIsUserLoggedIn,
                    setShowSupportPhoneNumber: setShowSupportPhoneNumber
                },
                routeId: ROUTE.MY_PROFILE,
            },
        },
    ];
    const filteredList = () => {
        const idsToRemove = [];
        if (isLoanRenewalInProgress) {
            idsToRemove.push('txt_profileScreen_loanForeclosure');
        }
        if (!showLoanDetails) {
            idsToRemove.push('txt_profileScreen_loanDetails');
        }
        if (!shouldShowContactUs) {
            idsToRemove.push('txt_profileScreen_contactUs');
        }
        if (showForeclosure || isLoanExpired) {
            idsToRemove.push('txt_profileScreen_loanForeclosure', 'txt_profileScreen_trackClosureRequest');
        }
        if (preLoanFlowUI) {
            if (showForeclosureTracking) {
                if (showForeclosureTrackingFromFirebase) {
                    idsToRemove.push('txt_profileScreen_loanForeclosure');
                }
                else {
                    idsToRemove.push('txt_profileScreen_trackClosureRequest', 'txt_profileScreen_loanForeclosure', 'txt_profileScreen_aboutUs');
                }
            }
            else {
                idsToRemove.push('txt_profileScreen_accountDetails', 'txt_profileScreen_trackClosureRequest', 'txt_profileScreen_loanForeclosure');
            }
        }
        else if (!showForeclosure) {
            idsToRemove.push('txt_profileScreen_trackClosureRequest');
        }
        if (!showLogout) {
            idsToRemove.push('txt_profileScreen_logOut');
        }
        return list.filter(item => !idsToRemove.includes(item.id));
    };
    const result = filteredList();
    return result;
    // if(isLoanRenewalInProgress){
    //     list.splice(4, 1)
    // }
    // if (!shouldShowContactUs) {
    //     list.splice(2, 1)
    // }
    // if (showForeclosure || isLoanExpired) {
    //     list.splice(4, 1)
    //     list.splice(3, 1)
    // }
    // if (preLoanFlowUI) {
    //     if (showForeclosureTracking) {
    //         if (showForeclosureTrackingFromFirebase) {
    //             list.splice(4, 1)
    //         } else {
    //             list.splice(4, 1)
    //             list.splice(5, 1)
    //             list.splice(3, 1)
    //         }
    //     } else {
    //         list.splice(0, 1);
    //         list.splice(3, 1);
    //         list.splice(2, 1);
    //     }
    // } else if(!showForeclosure) {
    //     list.splice(3, 1)
    // }
    // if (!showLogout) {
    //     list?.pop();
    // }
    // return list
};
export const template = (userName, initialUserLetter, profileData, showContactUs, isPendingForeclosure, preLoanFlowUI, showLogout, isLoanExpired, showForeclosureTracking, foreclosureTrackingResponse, showForeclosureTrackingFromFirebase, setIsUserLoggedIn, setShowSupportPhoneNumber, isLoanRenewalInProgress, showLoanDetails, showNewForeClosureScreen) => {
    const layoutList = menuList(profileData, showContactUs, isPendingForeclosure, preLoanFlowUI, showLogout, isLoanExpired, showForeclosureTracking, foreclosureTrackingResponse, showForeclosureTrackingFromFirebase, setIsUserLoggedIn, setShowSupportPhoneNumber, isLoanRenewalInProgress, showLoanDetails, showNewForeClosureScreen).map((item, index) => ({
        id: `${item.titleLabel}`,
        type: WIDGET.STACK,
        position: item.position,
    }));
    const datastore = menuList(profileData, showContactUs, isPendingForeclosure, preLoanFlowUI, showLogout, isLoanExpired, showForeclosureTracking, foreclosureTrackingResponse, showForeclosureTrackingFromFirebase, setIsUserLoggedIn, setShowSupportPhoneNumber, isLoanRenewalInProgress, showLoanDetails, showNewForeClosureScreen).reduce((acc, item) => {
        return {
            ...acc,
            ...buildListItem(item.id, item.titleLabel, item.titleColor, item.titleFontWeight, item.iconName, item.iconColor, item.hasRightArrow, item.hasDivider, item.action),
        };
    }, {});
    return {
        layout: {
            id: ROUTE.MY_PROFILE,
            type: LAYOUTS.LIST,
            widgets: [
                (Platform.OS === "ios" || Platform.OS === "android") ? {
                    id: "spaceXXL",
                    type: WIDGET.SPACE,
                    position: POSITION.ABSOLUTE_TOP
                } : {},
                {
                    id: 'header',
                    type: WIDGET.HEADER,
                    position: POSITION.ABSOLUTE_TOP,
                },
                ...layoutList,
            ],
        },
        datastore: {
            header: {
                title: `${userName}`,
                rightItem: {
                    uri: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/profile_pre1.png',
                    initialLetter: `${initialUserLetter}`,
                    type: AvatarTypeTokens.SINGLE,
                    size: AvatarSizeTokens.LG,
                    active: ActiveStateTokens.INACTIVE,
                    borderWidth: 1,
                    borderColor: ColorTokens.Primary_100,
                    borderRadius: BorderRadiusTokens.BR5,
                },
                shouldShowShadow: false,
                isBackButton: false,
                leftIcon: {
                    id: 'bt_profileScreen_goBack',
                    name: IconTokens.Cross,
                    size: IconSizeTokens.XXL,
                    color: ColorTokens.Grey_Charcoal,
                },
                type: HeaderTypeTokens.HEADERCTA,
                action: {
                    type: ACTION.BACK_BUTTON,
                    payload: {},
                    routeId: ROUTE.MY_PROFILE,
                },
            },
            spaceXXL: {
                size: SizeTypeTokens.XXL
            },
            ...datastore,
        },
    };
};
export const myProfileMF = {
    onLoad: async ({ network }, { response, target, setIsUserLoggedIn, setShowSupportPhoneNumber }) => {
        const showLogout = await SharedPropsService.getShowLogout();
        const user = await SharedPropsService.getUser();
        let preLoanFlowUI = false;
        let isPendingForeclosure = user?.linkedCredits[0]?.creditStatus === "PENDING_CLOSURE";
        const showNewForeClosureScreen = await showNewForeClosureFlow();
        let showLoanDetails = false;
        const creditStatus = user?.linkedCredits[0]?.creditStatus;
        const showUserLoanDetailsFlow = await showUserLoanDetils();
        if ((creditStatus === CREDIT_STATUS.APPROVED_NOT_DISBURSED || creditStatus === CREDIT_STATUS.ACTIVE) && showUserLoanDetailsFlow === true) {
            showLoanDetails = true;
        }
        else
            showLoanDetails = false;
        if (user.linkedApplications[0].applicationState === "COMPLETED") {
            // const manageLimitConfig = await network
            //     .get(
            //         `${api.manageLimitConfig}${user.linkedCredits[0].creditId}`, {headers: await getAppHeader()}).then(response => response.data)
            const manageLimitConfig = await getManageLimitConfig(network);
            let showNewFlow = manageLimitConfig.loanForeClosureAllowed;
            if (!isPendingForeclosure) {
                if (showNewFlow) {
                    isPendingForeclosure = false;
                }
                else {
                    isPendingForeclosure = true;
                }
            }
            preLoanFlowUI = false;
        }
        else
            preLoanFlowUI = true;
        // const responseX = response
        //     ? response
        //     : await network
        //         .get(
        //             `${api.userProfile}${user.linkedBorrowerAccounts[0].accountId}`,
        //             {headers: await getAppHeader()},
        //         )
        //         .then(response => response.data)
        const borrowerUserProfile = await getBorrowerProfile(network, {
            overrideCache: true
        });
        // const phoneNumber = responseX?.phoneNumber;
        // const updatedPhoneNumber = phoneNumber.slice(0, 3) + " " + phoneNumber.slice(3, phoneNumber.length);
        // const userName: string = (responseX?.name === null || responseX?.name === undefined) ? updatedPhoneNumber : responseX?.name
        // const formattedFullName = formatFullName(userName);
        const phoneNumber = borrowerUserProfile?.phoneNumber;
        const updatedPhoneNumber = phoneNumber.slice(0, 3) + " " + phoneNumber.slice(3, phoneNumber.length);
        const userName = (borrowerUserProfile?.name === null || borrowerUserProfile?.name === undefined) ? updatedPhoneNumber : borrowerUserProfile?.name;
        const formattedFullName = formatFullName(userName);
        const initialUserLetter = userName?.charAt(0) === "+" ? "" : userName?.charAt(0);
        const showContactUs = shouldShowVoltContactUs(await SharedPropsService.getURL());
        // const profileData = responseX
        const profileData = borrowerUserProfile;
        await AsyncStorage.removeItem("target");
        if (target && target === TARGET_PAGES.ACCOUNT) {
            removeUrlWithoutReload(QUERY_PARAMS.TARGET);
        }
        const isLoanExpired = await SharedPropsService.getIsLoanExpired();
        const isLoanRenewalInProgress = await SharedPropsService.getIsInProgressLoanRenewal();
        let showForeclosureTracking = false;
        let foreclosureTrackingResponse;
        const showForeclosureTrackingFromFirebase = await foreclosureTrackingFlag();
        if (user.linkedApplications[0].applicationState === 'IN_PROGRESS') {
            if (showForeclosureTrackingFromFirebase) {
                const getLoanForeclosureCompletedData = await network
                    .get(`${api.getForeclosureCompleted}${user.linkedBorrowerAccounts[0].accountId}`, { headers: await getAppHeader() });
                if (getLoanForeclosureCompletedData?.response?.data?.statusCode === "400") {
                    showForeclosureTracking = false;
                }
                else {
                    showForeclosureTracking = true;
                    foreclosureTrackingResponse = getLoanForeclosureCompletedData?.data;
                }
            }
        }
        return Promise.resolve(template(formattedFullName, initialUserLetter, profileData, showContactUs, isPendingForeclosure, preLoanFlowUI, showLogout, isLoanExpired, showForeclosureTracking, foreclosureTrackingResponse, showForeclosureTrackingFromFirebase, setIsUserLoggedIn, setShowSupportPhoneNumber, isLoanRenewalInProgress, showLoanDetails, showNewForeClosureScreen));
    },
    actions: {
        [ACTION.PROFILE]: accountDetails,
        [ACTION.CONTACT_US]: contactDetails,
        [ACTION.FAQ]: faqDetails,
        [ACTION.BACK_BUTTON]: goBack,
        [ACTION.LOGOUT]: logout,
        [ACTION.ABOUT]: aboutDetails,
        [ACTION.FORECLOSE]: navigateToForeclosure,
        [ACTION.TRACK_FORECLOSURE]: navigateForeClosureTracking,
        [ACTION.LOAN_PROFILE]: navigateToLoanDetails,
    },
    bgColor: '#FFFFFF',
};
